import { GenericBlocksConversionRules } from './generic/blocks/converter.rules'
import { TelegramBlocksConversionRules } from './telegram/blocks/converter.rules'
import { WhatsAppBlocksConversionRules } from './whatsapp/blocks/converter.rules'

export const BlocksConversionRules = [
  ...TelegramBlocksConversionRules,
  ...WhatsAppBlocksConversionRules,
  ...GenericBlocksConversionRules,
]
